<template>
    <div class="input-wrapper">
        <div class="input-name">{{inputName}}</div>
        <div class="coins" v-if="coins">
            1<div class="coin"></div>
        </div>
        <input type="text" :value="visValue" @input="emitValue">
    </div>
</template>

<script>
export default {
    name: 'SimpleInput',
    data: () => ({
        currentValue: '',
        visValue: '',
    }),
    methods: {
        emitValue(e) {
            let rez = '';
            if (this.mask) {
                rez = this.applyMask(e.target.value);
            } else {
                rez = e.target.value;
                this.currentValue = e.target.value;
            }
            this.visValue = rez;
            e.target.value = rez;
            this.$emit('input-value-emitter', {
                value: this.currentValue,
            });
        },

        applyMask(val) {
            if (this.mask.type === 'phone') {
                return this.applyPhoneMask(val);
            } else if (this.mask.type === 'birthday') {
                return this.applyPhoneMask(val);
            }
        },

        applyPhoneMask (val) {
            if (!val) return;
            let lastVal = val;
            let accumulator = '';
            this.currentValue = '';
            for (let counter=0; counter < this.mask.mask.length;  counter++) {
                if (this.mask.mask[counter] != '#') {
                    accumulator += this.mask.mask[counter];
                } else {
                    let c = 0;
                    let firstNumber = Array.from(lastVal).find((itm)=>{
                        c ++;
                        if (Number.isInteger(parseInt(itm))) {
                            return itm;
                        }
                    });
                    lastVal = lastVal.slice(c);
                    if (firstNumber) {
                        accumulator += firstNumber;
                        this.currentValue += firstNumber;
                    } else {
                        return accumulator;
                    }
                }
            }
            return accumulator;
        },
    },
    computed: {
    },
    mounted() {
        if (this.mask) {
            const regexp = RegExp('#');
            this.visValue = this.applyMask(this.inputValue.slice(0, this.mask.mask.matchAll(regexp).length));
            this.currentValue = this.inputValue;
        } else {
            this.visValue = this.inputValue;
            this.currentValue = this.inputValue;
        }

    },
    props:{
        mask: Object,
        inputName: String,
        inputValue: String,
        coins: Boolean,
    },
};
</script>

<style lang="scss" scoped>
    @import '../../../styles/rem';
    /*activate checkbox regExp in finder of phpStorm*/
    /*find      {: ([0-9]*)px}*/
    /*replace   {: rem($1);}*/

    .input-wrapper {
        border-radius: 0.2rem;
        border: rem(1) solid #98A0A9;
        width: 100%;
        height: 2.5rem;
        position: relative;

        .input-name {
            position: absolute;
            top: -0.4rem;
            left: 0.5rem;
            background: white;
            padding-left: 0.3rem;
            padding-right: 0.3rem;
            font-size: 0.6rem;
            font-weight: 600;
            color: #98A0A9;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
        }

        .coins {
            position: absolute;
            top: -0.4rem;
            right: 0.5rem;
            background: white;
            padding-left: 0.3rem;
            padding-right: 0.3rem;
            font-size: 0.6rem;
            font-weight: 600;
            color: #98A0A9;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;

            .coin {
                width: rem(16);
                height: rem(16);
                background: url(./../../../assets/images/account/coin.svg)
                    no-repeat center center;

                background-size: cover;
                border-radius: 50%;
                margin-left: rem(6);
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
            }
        }

        input {
            border: none;
            display: block;
            height: 100%;
            width: 100%;
            background: none;
            padding-left: 0.8rem;
            padding-right: 0.8rem;
            font-size: 0.8rem;
        }
    }
</style>
